import get from 'lodash/get';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import {
  SHORTENER_RESOLUTION_CLEAR,
  SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE,
  SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_ERROR,
  SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_FAILURE,
  SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_REQUEST,
  SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_SUCCESS,
} from '../../../actions/actionTypes';

const defaultState = {
  isLoading: false,
  response: {},
};

const linkToResolve = (state = defaultState, action) => {
  switch (action.type) {
    case SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_ERROR:
    case SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_FAILURE:
    case SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_SUCCESS: {
      const {
        payload: { response },
      } = action;

      return {
        response,
        isLoading: false,
      };
    }

    case SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE:
    case SHORTENER_RESOLUTION_CLEAR:
      return defaultState;

    default:
      return state;
  }
};

export default linkToResolve;

export const getShortenerResolutionLinkToResolve = state =>
  get(state, 'response.data', []) || [];

export const getShortenerResolutionNoMoreLinksToResolve = state =>
  state.response && state.response.status === HttpStatus.NOT_FOUND.value;
